import {useEffect} from 'react';
import SVG from 'svg.js';
import {addPanzoomHandlers} from '../utils/FloorplanWidgetUtils';
import {WidgetSvg} from './types';

const useFloorplanSvg = (
	floorplanSvg: string,
	uniqueSvgKey: string,
	key: string,
	setSvgRootObj: (arg0: WidgetSvg | undefined) => void
) => {
	useEffect(() => {
		let svgRootObj: WidgetSvg | undefined = undefined;

		if (floorplanSvg) {
			const svgNodeParser = new DOMParser();
			const svgNodeDom = svgNodeParser.parseFromString(floorplanSvg, 'application/xml');
			const svgNode = svgNodeDom.children[0];

			if (svgNode) {
				const idInWidget = `${uniqueSvgKey}_inWidget`;
				svgNode.setAttribute('id', idInWidget);
				const containerId = `svg-floorplan-${key}`;
				const container = document.getElementById(containerId);

				if (container) {
					if (container.children.length) {
						container.removeChild(container.children[0]);
					}

					container.appendChild(svgNode);
					svgRootObj = SVG(idInWidget) as unknown as WidgetSvg;
					addPanzoomHandlers(container);
				}
			}
		}

		setSvgRootObj(svgRootObj);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [floorplanSvg]);
};

export {useFloorplanSvg};
